import React from "react";
import { Container } from "basis";

import { ERROR_CODES } from "../constants";
import { NoLinkedAccounts } from "./NoLinkedAccounts";
import { AccountFetchError } from "./AccountFetchError";
import { AccountNotAvailable } from "./AccountNotAvailable";
import { InsufficientPoints } from "./InsufficientPoints";
import { logger } from "../../../core";
import styled, { css } from 'styled-components'
import { COLOR } from "../../../components/theme";

const StyledInnerContainer = styled.div`
  ${(props) =>
    props.color &&
    css`
      p,
      strong {
        color: ${props.color};
      }

      svg path {
        fill: ${props.color};
      }
    `}
`;

export const AccountErrors = ({ transactionId, minPoints = 0, errors, selectedAccount, orderPoints = 0, color = COLOR.LATITUDE_BLUE_INDIGO }) => {
  let errorCode = ERROR_CODES.ACCOUNT_FETCH_ERROR;

  if (errors?.length > 0) {
    const [firstError] = errors;
    logger.info(`wallet account fetch failed ${transactionId}`, {
      accErrors:errors
    })
    errorCode = firstError?.code;
  }else{
    errorCode = selectedAccount?.error?.code
  }

  const showAccountUnavailable =
    selectedAccount && !errorCode && !Boolean(selectedAccount?.isAvailable);

  return (
    <Container margin="0" border>
      <StyledInnerContainer color={color}>
        {errorCode === ERROR_CODES.ACCOUNT_FETCH_ERROR && <AccountFetchError color={color} />}

        {errorCode === ERROR_CODES.NO_ELIGIBLE_ACCOUNTS && <NoLinkedAccounts color={color} />}

        {errorCode === ERROR_CODES.INSUFFICIENT_POINTS && (
          <InsufficientPoints minPoints={minPoints} orderPoints={orderPoints} color={color} />
        )}

        {showAccountUnavailable && <AccountNotAvailable color={color} />}
      </StyledInnerContainer>
    </Container>
  );
};
